import { render, staticRenderFns } from "./user_active_time.vue?vue&type=template&id=b9c5c9ae&scoped=true"
import script from "./user_active_time.vue?vue&type=script&lang=ts"
export * from "./user_active_time.vue?vue&type=script&lang=ts"
import style0 from "./user_active_time.vue?vue&type=style&index=0&id=b9c5c9ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c5c9ae",
  null
  
)

export default component.exports